import React from 'react'

const AboutIconTwo = () => {
    return (
        <img src="https://img.icons8.com/ios-filled/50/000000/medal.png" alt="Multiple Commendations" style={{ width: '50px', height: '50px' }} />
    )
}

export default AboutIconTwo